/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import connect from "./../../utils/connect";
import AddDeviceToGroupDialog from "./AddDeviceToGroupDialog";
import {
  addDeviceToGroup,
  addInterfacesToGroup,
} from "../../api/groups/actions";
import { fetchComputerSystemsForAdd } from "./../../api/computer-systems/actions";
import { differenceBy } from "../../utils/lodash-utils";
import { addEntities } from "./../entities/actions";
import { fetchInterfacesToAdd } from "./../../api/interfaces/actions";
import { refreshTree } from "./../../api/treeView/actions";
const mapDispatchToProps = (dispatch) => {
  return {
    addToGroup: (
      groupId,
      deviceList,
      entities,
      openError,
      closeDialog,
      isInterfaceGroup
    ) => {
      let newListOfEntites = differenceBy(deviceList, entities, "id");
      if (newListOfEntites.length > 0) {
        if (isInterfaceGroup) {
          dispatch(addInterfacesToGroup(groupId, deviceList))
            .then((response) => {
              if (response.type === "ADD_INTERFACES_TO_GROUP_SUCCESS") {
                dispatch(addEntities(newListOfEntites));
                closeDialog("addDeviceToGroupOpen");
              } else {
                closeDialog("addDeviceToGroupOpen");
                openError("addDevices");
              }
            })
            .catch((error) => {
              closeDialog("addDeviceToGroupOpen");
              openError("addDevices");
            });
        } else {
          dispatch(addDeviceToGroup(groupId, deviceList))
            .then((response) => {
              if (response.type === "ADD_TO_GROUP_SUCCESS") {
                dispatch(addEntities(newListOfEntites));
                closeDialog("addDeviceToGroupOpen");
              } else {
                closeDialog("addDeviceToGroupOpen");
                openError("addDevices");
              }
            })
            .catch((error) => {
              closeDialog("addDeviceToGroupOpen");
              openError("addDevices");
            });
        }
      } else {
        closeDialog("addDeviceToGroupOpen");
      }
    },
    getAllComputerSystems: () => dispatch(fetchComputerSystemsForAdd()),
    getAllInterfaces: (filter) => dispatch(fetchInterfacesToAdd(filter)),
    refreshTree: () => dispatch(refreshTree(true)),
  };
};
const mapStateToProps = (state) => {
  return {
    didInvalidate: state.computerSystems.didInvalidate,
    isFetching: state.computerSystems.isFetching,
    isInterfaceGroup:
      state.tree_view.treeNode.isInterfaceGroup ||
      state.entity.masterElementGroup,
    groupId: state.tree_view.groupId,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddDeviceToGroupDialog);
